import { IconArrowUpRight, IconPlus } from '../../components/ui/Icon'

/**
 * The article's sources as a closed title block: a native <details>, so it
 * works without JS and keeps the browser's own keyboard and find-in-page.
 *
 * @param {{ label: string, sources: Array<{ title: string, url?: string }> }} props
 */
export default function PostSources({ label, sources }) {
    if (!sources || sources.length === 0) return null

    return (
        <details className="post-sources">
            <summary className="post-sources-summary">
                <span className="post-sources-title">{label}</span>
                <span className="post-sources-count legend tabular">{sources.length}</span>
                <IconPlus className="post-sources-icon" size={22} />
            </summary>

            <ol className="post-sources-list">
                {sources.map((source, index) => {
                    const number = `[${index + 1}]`
                    return (
                        <li key={`${index}:${source.title}`}>
                            {source.url ? (
                                <a
                                    href={source.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="post-source"
                                >
                                    <span className="post-source-num legend tabular">{number}</span>
                                    <span className="post-source-title">{source.title}</span>
                                    <IconArrowUpRight className="post-source-go" size={16} />
                                </a>
                            ) : (
                                <span className="post-source">
                                    <span className="post-source-num legend tabular">{number}</span>
                                    <span className="post-source-title">{source.title}</span>
                                </span>
                            )}
                        </li>
                    )
                })}
            </ol>
        </details>
    )
}
